<template>
    <div class="header">
        <div class="outer clearfix">
            <div class="left"><router-link to="/"><img src="../assets/img/logo4.png" alt=""></router-link></div>
            <ul class="right clearfix">
                <!-- <li class="right-item active"><router-link to="/">资讯</router-link></li> -->
                <!-- <li class="right-item active"><router-link to="/about">关于我们</router-link></li> -->
                <!-- <li class="right-item code" @mouseover='mouseoverCode' @mouseout='mouseoutCode'><a >微信公众号</a><div class="img" v-show='showcode'><img src="../assets/code.jpg" alt=""></div></li> -->
            </ul>
            <!-- <div class="search clearfix">
                <img src="../assets/img/searchIcon.png" alt="">
                <input type="text" placeholder="搜索你感兴趣的内容~" v-model='keywords' @keydown.enter='clickToSearch'>
                <div class="btn" @click='clickToSearch'>搜索</div>
            </div> -->
            <!-- <ul class="log clearfix">
                <li class="log-item code clearfix" @mouseover='mouseoverDownCode' @mouseout='mouseoutDownCode'>
                    <img class="item-show" src="../assets/img/downIcon1.png" alt="">
                    <span class="item-show">下载APP</span>
                    <div class="down-code" v-show='showDownCode'>
                        <img class="down-code" src="../assets/img/down/code.png" alt="">
                    </div>
                </li>
                <li class="log-item user clearfix" v-if='!nickName' ><img class="item-show" src="../assets/img/user.png" alt=""><span class="item-show"><span @click='clickToLogin' class="user-text">登录</span><span class="user-xie">/</span><span class="user-text" @click='clickToRegister'>注册</span></span></li>
                <li class="log-item" v-else><span class="sp1">{{nickName}}</span><span class="sp-gap"> | </span><span @click='clickToLogout'>退出</span></li>
            </ul> -->
        </div>
        <Login v-if='showLogin' @closeLogin='closeLogin' @clickToShowRegister='clickToShowRegister' @clickToShowFogetPassword='clickToShowFogetPassword'></Login>
        <AddMobile v-if='showAddMobile' @returnLogin='returnLogin' @loginSuccess='loginSuccess'></AddMobile>
        <Register v-if='showRegister' @closeRegister='closeRegister' @registerSuccess='registerSuccess'></Register>
        <ForgetPassword v-if='showForgetPassword' @closeFogetPassword='closeFogetPassword' @forgetPasswordSuccess='forgetPasswordSuccess'></ForgetPassword>
    </div>
</template>

<script>
import {consoleUrl,appUrl,getQueryString,getCookie} from '../tool/tool.js'
export default {
    components: {
        'Login': () => import('../components/login'),
        'AddMobile': () => import('../components/addMobile'),
        'Register': () => import('../components/register'),
        'ForgetPassword': () => import('../components/forgetPassword')
    },
    data () {
        return {
            keywords: '',
            showcode: false,
            showLogin: false,
            showAddMobile: false,
            showRegister: false,
            showForgetPassword: false,
            nickName: '',
            showDownCode: false
        }
    },
    watch: {
        '$store.state.formPeopleCarLogin': function(val) {
            console.log(this.$store.state.formPeopleCarLogin)
            if(val == 'needLogin'){
                this.showLogin = true;
            }
            this.$store.commit('setFormPeopleCarLogin','noNeedLogin');
            console.log(this.$store.state.formPeopleCarLogin)
        }
    },
    methods: {
        clickToSearch(){
            if(this.keywords){
                if(window.localStorage.lastWord){
                    let arr = JSON.parse(window.localStorage.lastWord);
                    if(arr.length < 5){
                        arr.unshift(this.keywords);
                    }else if(arr.length == 5){
                        arr = arr.slice(0,4);
                        arr.unshift(this.keywords);
                    }
                    window.localStorage.lastWord = JSON.stringify(arr)
                }else{
                    let arr = [this.keywords];
                    window.localStorage.lastWord = JSON.stringify(arr)
                }
                this.$router.push({path:'/search?keywords='+this.keywords});
                this.keywords = '';
            }else{
                this.$notify({
                    title: '提示',
                    message: '请输入关键词进行搜索',
                    type: 'warning'
                });
            }
        },
        forgetPasswordSuccess(){
            this.showForgetPassword = false;
            this.$message({
                message: '密码修改成功。',
                type: 'success'
            });
        },
        closeFogetPassword(){
            this.showForgetPassword = false;
        },
        clickToShowFogetPassword(){
            this.showLogin = false;
            let _this = this;
            setTimeout(function(){
                _this.showForgetPassword = true;
            },100)
        },
        registerSuccess(){
            this.showRegister = false;
            this.$message({
                message: '恭喜您，注册成功。',
                type: 'success'
            });
        },
        closeRegister(){
            this.showRegister = false;
        },
        clickToShowRegister(){
            this.showLogin = false;
            let _this = this;
            setTimeout(function(){
                _this.showRegister = true;
            },100)
        },
        clickToLogout(){
            this.$alert('确认退出吗？', '提示', {
                confirmButtonText: '确定',
                callback: action => {
                    if(action == 'confirm'){
                        this.$http.post(consoleUrl+'/user',{
                            _action: 'LOGOUT'
                        }).then(response => {
                            if(response.data.success){
                                window.history.go(0)
                            }
                        }).catch( error => {
                        })
                    }
                    
                }
            });
            
        },
        mouseoverCode(){
            mixpanel.track("Scan code");
            this.showcode = true;
        },
        mouseoutCode(){
            this.showcode = false;
        },
        mouseoverDownCode(){
            this.showDownCode = true;
        },
        mouseoutDownCode(){
            this.showDownCode = false;
        },
        clickToLogin(){
            mixpanel.track("Login click");
            console.log(mixpanel)
            this.showLogin = true;
        },
        clickToRegister(){
            this.showRegister = true;
        },
        closeLogin(){
            this.showLogin = false;
        },
        returnLogin(){
            this.showAddMobile = false;
            let _this = this;
            setTimeout(function(){
                _this.showLogin = true;
            },100)
        },
        loginSuccess(data){
            this.showAddMobile = false;
            window.location.href = appUrl;
        },
        initState(){
            let num = getQueryString('authError');
            if(num){
                if(num == '5'){
                    this.showAddMobile = true;
                }else{
                    this.$notify({
                        title: '提示',
                        message: '登录失败，请重试',
                        type: 'error'
                    });
                }
            }else{
                let userId = getCookie('kaopu.login_user_id');
                let sId = getCookie('kaopu.login_s_id');
                if(userId){
                    this.getUserInfo(userId,sId);
                    this.$store.commit('setLoginStatue','yes')
                }else{
                    this.$store.commit('setLoginStatue','no')
                }
                
            }
            
        },
        getUserInfo(userId,sId){
            this.$http.post(consoleUrl+'/user',{
                _action: 'USER_INFO_1.4',
                'kaopu.login_user_id': userId,
                'kaopu.login_s_id': sId
            }).then(response => {
                // console.log(response)
                if(response.data.success){
                    this.nickName = response.data.user.nickName;
                }
            }).catch( error => {
            })
        }
    },
    mounted(){
        this.initState();
    }
}
</script>
<style scoped lang='less'>
    .header{
        background: #fff;
        box-shadow: 1px 1px 1px 1px rgba(204, 204, 204, 0.5);
        color: #333333;
        font-size: 15px;
        a{
            color: #333333;
        }
        .left{
            float: left;
            width: 128px;
            a:hover{
                color: #008bff;
            }
            img{
                margin: 16px 0;
            }
        }
        .right{
            float: left;
            margin-left: 35px;
            line-height: 60px;
            .right-item{
                float: left;
                padding: 0 15px;
                cursor: pointer;
                a{
                    display: block;
                    width: 100%;
                    height: 100%;
                    // padding: 0 15px;
                }
                a:hover{
                    font-weight: 600;
                }
            }
            .router-link-active.router-link-exact-active{
                border-bottom: 2px solid #008bff;
                font-weight: 600;
            }
            .code{
                position: relative;
                .img{
                    position: absolute;
                    box-shadow:0 0 2px 2px rgba(0,0,0,.2);
                    img{
                        width: 150px;
                    }
                    bottom: -110px;
                    left: 0;
                }
            }
        }
        .search{
            float: left;
            margin: 10px 0 10px 50px;
            position: relative;
            img{
                position: absolute;
                left: 13px;
                top: 10px;
            }
            input{
                width: 230px;
                height: 34px;
                border: 1px solid #dddddd;
                padding-left: 10px;
                float: left;
                font-size: 14px;
                padding-left: 50px;
            }
            .btn{
                float: left;
                width: 90px;
                height: 38px;
                background: #008bff;
                color: #fff;
                text-align: center;
                line-height: 38px;
                cursor: pointer;
                &:hover{
                    background: #0184f1;
                }
            }
        }
        .log{
            float: right;
            line-height: 60px;
            color: #999999;
            font-size: 14px;
            .log-item{
                float: left;
                // .item-show:hover{
                //     color: #008bff;
                //     cursor: pointer;
                // }
                .sp1{
                    color: #008bff;
                    width: 110px;
                    overflow: hidden;
                    height: 60px;
                    text-overflow:ellipsis;
                    white-space: nowrap;
                }
                .sp-gap{
                    margin: 0 5px;
                }
                span{
                    cursor: pointer;
                    float: left;
                }
            }
            .code{
                margin-right: 10px;
                position: relative;
                .item-show{
                    float: left;
                }
                img.item-show{
                    margin: 21px 10px 0 0;
                }
                .down-code{
                    position: absolute;
                    width: 256px;
                    height: 141px;
                    right: 0;
                    top: 30px;
                    z-index: 999;
                }
            }
            .user{
                img,span{
                    float: left;
                }
                .user-text:hover{
                    color: #008bff;
                    cursor: pointer;
                }
                img{
                    margin: 22px 10px 0 0;
                }
                .user-xie{
                    margin: 0 5px;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/head.vue